export const addTrailingSlash = (str: string) => (str?.at?.(-1) === '/' ? str : str + '/');
